export const PART_PARTS = [
  'container',
  'thumbnailContainer',
  'labelContainer',
  'labelGroup',
  'label',
  'labelPrefix',
  'labelPlaceholder',
  'secondaryLabel',
  'badgeContainer',
] as const;
